import BaseApiService from './BaseApiService';

import filters from '../../constants/filters';

class GrowthRateApiService extends BaseApiService {
    constructor() {
        super('growth-rate');
    }

    buildQueryParams(growthRates, growthRatesQuarters, companies, categories, subcategories, classes, brands, excludeBrands, tags, quarterData) {
        const queryParams = {};

        if (growthRates.length > 0) {
            queryParams.growthRates = growthRates.join(',');
        } else {
            queryParams.growthRates = filters.growthRates.map(filter => filter.value).join(',');
        }

        if (growthRatesQuarters && growthRatesQuarters.length > 0) {
            queryParams.growthRatesQuarters = growthRatesQuarters.join(',');
        } else {
            queryParams.growthRatesQuarters = filters.growthRatesQuarters.map(filter => filter.value).join(',');
        }

        if (companies.length > 0) {
            queryParams.companies = companies.join(',');
        }

        if (categories.length > 0) {
            queryParams.categories = categories.join(',');
        }

        if (subcategories.length > 0) {
            queryParams.subcategories = subcategories.join(',');
        }

        if (classes.length > 0) {
            queryParams.classes = classes.join(',');
        }

        if (brands.length > 0) {
            queryParams.brands = brands.join(',');
        }

        if (excludeBrands.length > 0) {
            queryParams.excludeBrands = excludeBrands.join(',');
        }

        if (tags.length > 0) {
            queryParams.tags = tags.join(',');
        }

        if (quarterData) {
            queryParams.quarterData = quarterData;
        }

        return queryParams;
    }

    async getAll({ growthRates, growthRatesQuarters, companies, categories, subcategories, classes, brands, excludeBrands, tags, quarterData }) {
        const params = this.buildQueryParams(growthRates, growthRatesQuarters, companies, categories, subcategories, classes, brands, excludeBrands, tags, quarterData);
        const response = await this.request({ method: 'get', url: '', params });

        return response && response.revenues ? response.revenues : [];
    }
}

export default new GrowthRateApiService();
